module.exports = __webpack_public_path__ + "img/Family.a9af550c.svg";